import { createSelector } from 'reselect';
import { AppState } from '../store';

export const selectReportsState = (state: AppState) => state.reports;
const selectReports = (state: any) => state.marketReport;
const selectTotal = (state: any) => state.total;

const selectMonthlyReport = (state: any) => state.monthlyReport;
const selectMonthlyReportLoading = (state: any) => state.monthlyReportLoading;
const selectMonthlyReportError = (state: any) => state.monthlyReportError;

export const selectMarketReport = createSelector(
  selectReportsState,
  selectReports,
);

export const selectTotalReports = createSelector(
  selectReportsState,
  selectTotal,
);

export const selectMonthlyReportData = createSelector(
  selectReportsState,
  selectMonthlyReport,
);

export const selectMonthlyReportLoadingState = createSelector(
  selectReportsState,
  selectMonthlyReportLoading,
);

export const selectMonthlyReportErrorState = createSelector(
  selectReportsState,
  selectMonthlyReportError,
);
